module.exports = __webpack_public_path__ + "static/media/checked-box.82d75f0f.svg";